
export const regexp = {
  // email: /^([\w-+]|[\w.+])+@[(\w-+)]+(\.)+([\w]){2,14}$/,
  email: /^([\w-+]|[\w.+])+@[(\w-+)]+([\w.+]){2,14}$/,
  mobilePhone: /^1\d{10}$|^(0\d{2,3}-?|\(0\d{2,3}\))?[1-9]\d{4,7}(-\d{1,8})?$/,
  mobileRegitsterPhone: /^[1][3-9][0-9]{9}$/,
  userName: /^[a-zA-Z0-9_-]{1,20}$/,
  userNameRegister: /^[a-zA-Z0-9-]{6,20}$/,
  mima: /^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,20}$/,
  // mimaRegister: /^(?!^(\\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\\w~!@#$%^&*?]{6,20}$/,
  // mimaRegister: /^(?![d]+$)(?![a-z]+$)(?![A-Z]+$)(?![!#$%^&*]+$)[da-zA-z!#$%^&*]{6,20}$/,
  // mimaRegister: /^(?!^\d+$)(?!^[a-z]+$)(?!^[A-Z]+$)(?!^[^a-z0-9]+$)(?!^[^A-Z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S*$/,
  mimaRegister: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#^()@$!%*?&.])[A-Za-z\d#^()@$!%*?&.]{12,20}$/,
  mimaRepeatRegister: /([a-zA-Z])\1{2}|012|123|234|345|456|567|678|789|890|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|ABC|BCD|CDE|DEF|EFG|FGH|GHI|HIJ|IJK|JKL|KLM|LMN|MNO|NOP|OPQ|PQR|QRS|RST|STU|TUV|UVW|VWX|WXY|XYZ|\!\@\#|\@\#\$|\#\$\%|\$\%\^|\%\^\&|\^\&\*|\&\*\(|\*\(\)/,
  validValue: /^[A-Za-z0-9-\u4e00-\u9fa5]+$/, // 中文英文数字 和减号,
  validName: /^[\u4e00-\u9fa5*a-zA-Z0-9]{0,255}$/,
  validGroup: /^[A-Za-z0-9_\-\u4e00-\u9fa5]+$/, // 中文英文数字下划线 和减号,
  validNumber: /^[A-Za-z0-9]{0,255}$/,
  validInt: /^[1-9]\d*$/,
  validNum: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)|^0$/,
  validNumFour: /(^[1-9]\d*(\.\d{1,4})?$)|(^0(\.\d{1,4})?$)|^0$/,
}

export const isExternal = (path) => {
  return /^(https?:|mailto:|tel:)/.test(path)
}
export const checkPwd = (value) => {
  return regexp.mima.test(value)
}
export const checkPwdRegister = (value) => {
  return regexp.mimaRegister.test(value)
}
export const checkPwdRepeatRegister = (value) => {
  return regexp.mimaRepeatRegister.test(value)
}
/* 校验用户名 */
export const checkUserName = (value) => {
  return regexp.userName.test(value)
}
export const checkUserNameRegister = (value) => {
  return regexp.userNameRegister.test(value)
}
/* 电子邮箱 */
export const checkEmail = (value) => {
  return regexp.email.test(value)
}

/* 电子邮箱 */
export const checkMobilePhone = (value) => {
  return regexp.mobilePhone.test(value)
}
export const checkMobileRegitsterPhone = (value) => {
  return regexp.mobileRegitsterPhone.test(value)
}

/* 判断大于0的正整数 */
export const isIntGt0 = (value) => {
  return regexp.validInt.test(value)
}
/* 价格校验 可以为0 */
export const isNum = (value) => {
  return regexp.validNum.test(value)
}
export const isNumFour = (value) => {
  return regexp.validNumFour.test(value)
}